export default __webpack_public_path__ + "static/media/department2.f63b7ee7.png";